import { getNodeUUID } from "@/utils";
import { cloneDeep, merge } from "lodash-es";

const dragCreateNodeOpt = {
  getEvents() {
    return {
      "canvas:drop": "onCanvasDrop",
    };
  },
  getNodeTypeDefaultData(nodeType) {
    return {};
  },
  onCanvasDrop({ clientX, clientY, originalEvent }) {
    if (!originalEvent.dataTransfer) return; // 不是拖动新建

    const nodeType = originalEvent.dataTransfer.getData("text/plain");
    const nodeOpt = this.nodeList.find((node) => node.type === nodeType);

    if (!nodeOpt) return;
    const point = this.graph.getPointByClient(clientX, clientY);
    // https://g6.antv.antgroup.com/api/graph-func/on_off#graphemiteventname-params

    this.graph.emit("dragCreateNode", {
      nodeType,
      position: {
        x: point.x,
        y: point.y,
      },
      nodeData: cloneDeep(this.getNodeTypeDefaultData(nodeType)),
    });
    // 弹出设置面板
    // this.graph.emit("clickNode", { item: node, isNewNode: true });
  },
};

export const getDragCreateNodeOpt = (opt) => {
  return merge({}, dragCreateNodeOpt, opt);
};
